import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "text-center" },
    [
      _c(
        VDialog,
        {
          ref: "dialog",
          attrs: { width: _vm.width, persistent: true, scrollable: "" },
          on: { keydown: _vm.onKeydown },
          model: {
            value: _vm.isOpen,
            callback: function ($$v) {
              _vm.isOpen = $$v
            },
            expression: "isOpen",
          },
        },
        [
          _c(
            VCard,
            [
              _c(
                VCardTitle,
                { class: _vm.titleClass, attrs: { "primary-title": "" } },
                [
                  _vm.custom_title
                    ? _vm._t("title")
                    : [_vm._v(" " + _vm._s(_vm.title) + " ")],
                  _vm.closable
                    ? _c(
                        VBtn,
                        {
                          staticClass: "close",
                          staticStyle: { position: "absolute", right: "15px" },
                          attrs: {
                            icon: "",
                            "aria-label":
                              _vm.closeLabel || _vm.$t("btns.close"),
                          },
                          on: { click: _vm.onClose },
                        },
                        [_c(VIcon, [_vm._v("icon-decline")])],
                        1
                      )
                    : _vm._e(),
                ],
                2
              ),
              _vm.isOpen
                ? _c(
                    VCardText,
                    { staticClass: "pb-0 pt-2 pl-3 pr-3" },
                    [_vm._t("body")],
                    2
                  )
                : _vm._e(),
              _c(VDivider),
              _vm.showButtons
                ? _c(
                    VCardActions,
                    { staticClass: "pt-1 pl-3 pr-3 pb-3" },
                    [
                      _vm._t("btnsLeft"),
                      _c(VSpacer),
                      _vm.showCancelButton
                        ? _c(
                            VBtn,
                            {
                              staticClass: "default",
                              attrs: { text: "", outlined: "" },
                              on: {
                                click: function ($event) {
                                  return _vm.onClose()
                                },
                              },
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("btns.cancel")) + " ")]
                          )
                        : _vm._e(),
                      _vm._t("btnsRight"),
                    ],
                    2
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }